import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from 'components/form-fields';
import { ReviewTriggersTable } from 'pages/employee-reviews/shared';

const defaultObject = {};
const defaultArray = [];

// Both tables take the same widths so the review type's triggers line up with the driver's.
const triggersColumnWidths = ["280px", null, "90px"];

// The driver's additional triggers beneath the review type's own, which are shown for reference
// and cannot be changed here. Only trigger types for the given topics are offered.
export function AdditionalTriggersStep(
    {
        reviewTypeTriggers = defaultArray,
        employeeTriggers = defaultArray,
        topicIds = defaultArray,
        reviewOptions = defaultObject,
        errors = defaultObject,
        loading = false,
        saving = false,
        onEmployeeTriggersChange
    }
) {

    return (
        <div>
            <h2>Additional triggers</h2>
            <FormHelperText loading={loading}>Choose what else raises this employee's reviews of this type.</FormHelperText>
            <ReviewTriggersTable
                heading="Set on the review type"
                emptyMessage="This review type has no triggers of its own."
                triggers={reviewTypeTriggers}
                topicIds={topicIds}
                reviewOptions={reviewOptions}
                idPrefix="additional-triggers-review-type"
                loading={loading}
                disabled
                columnWidths={triggersColumnWidths}
            />
            <ReviewTriggersTable
                heading="For this employee"
                helperText="These are added to the review type's triggers above. They can bring this employee's review forward but cannot delay it."
                triggers={employeeTriggers}
                onChange={onEmployeeTriggersChange}
                topicIds={topicIds}
                errors={errors}
                reviewOptions={reviewOptions}
                idPrefix="additional-triggers-employee"
                loading={loading}
                saving={saving}
                columnWidths={triggersColumnWidths}
            />
        </div>
    );
}

AdditionalTriggersStep.propTypes = {
    reviewTypeTriggers: PropTypes.array,
    employeeTriggers: PropTypes.array,
    topicIds: PropTypes.arrayOf(PropTypes.number),
    reviewOptions: PropTypes.object,
    errors: PropTypes.object,
    loading: PropTypes.bool,
    saving: PropTypes.bool,
    onEmployeeTriggersChange: PropTypes.func.isRequired
};
